import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserProfileService } from 'src/app/core/api-services/user-profile/user-profile.service';
import {
  AuthorityProfileModel,
  PersonProfileModel,
  UserProfileLookups,
} from 'src/app/core/models/user-profile/user-profile.model';
import { ProfileMapper } from '../shared/profile-mapper';
import { BaseProfileComponent } from '../shared/base-profile.component';
import { TranslateService } from '@ngx-translate/core';
import { AlertImportanceEnum } from 'src/app/shared/bs-alert/AlertImportanceEnum';

@Component({
  selector: 'app-user-profile',
  templateUrl: 'user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent
  extends BaseProfileComponent
  implements OnInit
{
  isProfileLoaded: boolean = false;
  isPerson: boolean = false;
  isOwner: boolean = false;
  person: PersonProfileModel;
  authority: AuthorityProfileModel;
  lookups: UserProfileLookups = new UserProfileLookups();
  importance = AlertImportanceEnum;

  form: FormGroup = new FormGroup({});

  constructor(
    translateService: TranslateService,
    protected _mapper: ProfileMapper,
    private _service: UserProfileService,
    private changedetectionRef: ChangeDetectorRef
  ) {
    super(translateService, _mapper);
  }

  ngOnInit(): void {
    this._service.GetUserProfile().subscribe((response) => {
      if (response) {
        this.isProfileLoaded = true;
        this.isPerson = response.ProfileData.PersonToRegister != null;
        if (this.isPerson) {
              this.person = this._mapper.mapPersonProfile(
                response.ProfileData,
                this._mapper.mapLookups(response.PersonRegistrationLookup)
              );
              this.person.IsVerified = true;
              this.isOwner = this.person.IsOwner = response.IsPowerUser;
              this.changedetectionRef.detectChanges();
              this.setFormValue(this.person);
              this.lookups = this._mapper.mapLookups(
                response.PersonRegistrationLookup
              );
        } else {
          this._service
            .GetLicenseIssuers(
              response.ProfileData?.ParticipantToRegister?.EmirateId
            )
            .subscribe((licenseIssuers) => {
              response.AuthorityRegistrationLookup.LicenseIssuers =
                  licenseIssuers;
              this.isOwner = response.IsPowerUser;
              this.authority = this._mapper.mapAuthorityProfile(
                response.ProfileData,
                this._mapper.mapLookups(response.AuthorityRegistrationLookup)
              );
              this.changedetectionRef.detectChanges();
              this.setFormValue(this.authority);
              this.lookups = this._mapper.mapLookups(
                response.AuthorityRegistrationLookup
              );
            });
        }
      }
    });
  }

  save() {
    this.showError = false;
    this.showSuccess = false;
    if (this.form.valid) {
      var saveProfileApi;
      if (this.isPerson) {
        saveProfileApi = this._service.SaveProfile(
          this._mapper.mapPersonData(this.form.getRawValue())
        );
      } else {
        saveProfileApi = this._service.SaveProfile(
          this._mapper.mapAuthorityData(this.form.getRawValue())
        );
      }

      saveProfileApi.subscribe(
        (response) => {
          this.displaySuccess('ProfileSuccessMessage');
        },
        (error) => {
          this.displayError(error.Message);
        }
      );
    } else {
      this.form.markAllAsTouched();
      this.focusOnError();
    }
  }
}
